import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipCardComponent } from './components/tip-card/tip-card.component';
import { SharedModule } from '../../shared/shared.module';
import { CloseBtnModule } from '../close-btn/close-btn.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    CloseBtnModule,
    ReactiveFormsModule,
    FormsModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatNativeDateModule,
    ComponentLoader
  ],
  declarations: [TipCardComponent],
  exports: [TipCardComponent],
})
export class TipCardModule { }
